import { _ as _type_of } from "@swc/helpers/_/_type_of";
var isFunction = function(obj) {
  return typeof obj === "function";
};
function validatePlugin(plugin) {
  var type = typeof plugin === "undefined" ? "undefined" : _type_of(plugin);
  if (type !== "object" || plugin === null) {
    throw new Error("Expect CLI Plugin instance to be an object, but got ".concat(type, "."));
  }
  if (!plugin.setup)
    return;
  if (isFunction(plugin.setup)) {
    return;
  }
  throw new Error("Expect CLI Plugin plugin.setup to be a function, but got ".concat(type, "."));
}
function createPluginManager() {
  var plugins = /* @__PURE__ */ new Map();
  var dependencies = /* @__PURE__ */ new Map();
  var addDependency = function(plugin, dependency, type) {
    if (!dependencies.has(dependency)) {
      dependencies.set(dependency, {
        pre: /* @__PURE__ */ new Map(),
        post: /* @__PURE__ */ new Map()
      });
    }
    if (type === "pre") {
      dependencies.get(plugin).pre.set(dependency, {
        name: dependency,
        isUse: false
      });
    } else if (type === "post") {
      dependencies.get(plugin).post.set(dependency, {
        name: dependency
      });
    } else if (type === "use") {
      if (!dependencies.get(plugin).post.has(dependency) && !dependencies.get(dependency).pre.has(plugin)) {
        dependencies.get(plugin).pre.set(dependency, {
          name: dependency,
          isUse: true
        });
      }
    }
  };
  var addPlugin = function(newPlugin) {
    if (!newPlugin) {
      return;
    }
    validatePlugin(newPlugin);
    var name = newPlugin.name, _newPlugin_usePlugins = newPlugin.usePlugins, usePlugins = _newPlugin_usePlugins === void 0 ? [] : _newPlugin_usePlugins, _newPlugin_pre = newPlugin.pre, pre = _newPlugin_pre === void 0 ? [] : _newPlugin_pre, _newPlugin_post = newPlugin.post, post = _newPlugin_post === void 0 ? [] : _newPlugin_post;
    if (plugins.has(name)) {
      console.warn("Plugin ".concat(name, " already exists."));
      return;
    }
    plugins.set(name, newPlugin);
    dependencies.set(name, {
      pre: /* @__PURE__ */ new Map(),
      post: /* @__PURE__ */ new Map()
    });
    pre.forEach(function(dep) {
      addDependency(name, dep, "pre");
    });
    post.forEach(function(dep) {
      addDependency(name, dep, "post");
    });
    usePlugins.forEach(function(plugin) {
      if (!plugins.has(plugin.name)) {
        addPlugin(plugin);
      }
      addDependency(name, plugin.name, "use");
    });
  };
  var addPlugins = function(newPlugins) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = newPlugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var newPlugin = _step.value;
        addPlugin(newPlugin);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
  var getPlugins = function() {
    var visited = /* @__PURE__ */ new Set();
    var temp = /* @__PURE__ */ new Set();
    var result = [];
    var visit = function(name) {
      if (temp.has(name)) {
        throw new Error("Circular dependency detected: ".concat(name));
      }
      if (!visited.has(name) && plugins.get(name)) {
        temp.add(name);
        var _plugins_get = plugins.get(name), _plugins_get_required = _plugins_get.required, required = _plugins_get_required === void 0 ? [] : _plugins_get_required;
        required.forEach(function(dep) {
          if (!plugins.get(dep)) {
            throw new Error("".concat(name, " plugin required plugin ").concat(dep, ", but not found."));
          }
        });
        var pre = dependencies.get(name).pre;
        Array.from(pre.values()).filter(function(dep) {
          return !dep.isUse;
        }).forEach(function(dep) {
          return visit(dep.name);
        });
        Array.from(pre.values()).filter(function(dep) {
          return dep.isUse;
        }).forEach(function(dep) {
          return visit(dep.name);
        });
        temp.delete(name);
        visited.add(name);
        result.push(plugins.get(name));
      }
    };
    plugins.forEach(function(_, name) {
      var post = dependencies.get(name).post;
      post.forEach(function(dep) {
        if (!dependencies.get(dep.name).pre.has(name)) {
          dependencies.get(dep.name).pre.set(name, {
            name,
            isUse: false
          });
        }
      });
    });
    plugins.forEach(function(_, name) {
      visit(name);
    });
    result = result.filter(function(result2) {
      return result2;
    });
    return result;
  };
  var clear = function() {
    plugins.clear();
    dependencies.clear();
  };
  return {
    getPlugins,
    addPlugins,
    clear,
    isPluginExists: function(name) {
      return plugins.has(name);
    }
  };
}
export {
  createPluginManager
};
